import { render, staticRenderFns } from "./QuickReplyAnswer.vue?vue&type=template&id=5185d92c&scoped=true&"
import script from "./QuickReplyAnswer.vue?vue&type=script&lang=js&"
export * from "./QuickReplyAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuickReplyAnswer.vue?vue&type=style&index=0&id=5185d92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185d92c",
  null
  
)

export default component.exports